import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, Matching } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useIsMatchingProcessingQuery(
	dealGuid?: Guid | undefined,
	options?: Omit<UseQueryOptions<boolean, unknown, boolean, any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Matching.Processing(dealGuid),
		() => AxiosUtils.getResponseData<boolean>(api.get(CerebroApiEndpoints.Matching.Processing(dealGuid))),
		options
	);
}
